const CommonConstant = {};

CommonConstant.NETWORK_ERROR = 'Error occured, Please try again later';

export default CommonConstant;
